import { render, staticRenderFns } from "./LicenseRequest.vue?vue&type=template&id=2734f4fd&"
import script from "./LicenseRequest.vue?vue&type=script&lang=js&"
export * from "./LicenseRequest.vue?vue&type=script&lang=js&"
import style0 from "./LicenseRequest.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports